import React, { useContext, useState } from "react";
import { Button, Input, Select } from "antd";
import { EditOutlined } from "@ant-design/icons";
import mainContext from "../context/MainContext/mainContext";

const { Option } = Select;

const SalesOrderForm = ({
  salesOrderData,
  handleFormChange,
  log,
  onSaveBrandName,
  onSaveMotherBrand,
}) => {
  let { justView } = useContext(mainContext);
  const [brandEdit, setBrandEdit] = useState(false);
  const [brandDraft, setBrandDraft] = useState("");
  const [savingBrand, setSavingBrand] = useState(false);
  const [motherBrandEdit, setMotherBrandEdit] = useState(false);
  const [motherBrandDraft, setMotherBrandDraft] = useState("");
  const [savingMotherBrand, setSavingMotherBrand] = useState(false);

  const startBrandEdit = () => {
    setBrandDraft(
      salesOrderData?.brandName
        ? String(salesOrderData.brandName).trim().toUpperCase()
        : ""
    );
    setBrandEdit(true);
  };

  const handleSaveBrand = async () => {
    if (justView || !onSaveBrandName) return;
    const next = brandDraft.trim().toUpperCase();
    const prev = salesOrderData?.brandName
      ? String(salesOrderData.brandName).trim().toUpperCase()
      : "";
    if (next === prev) {
      setBrandEdit(false);
      return;
    }
    setSavingBrand(true);
    try {
      const ok = await onSaveBrandName(next);
      if (ok) setBrandEdit(false);
    } finally {
      setSavingBrand(false);
    }
  };

  const startMotherBrandEdit = () => {
    setMotherBrandDraft(
      salesOrderData?.motherBrand
        ? String(salesOrderData.motherBrand).trim().toUpperCase()
        : "",
    );
    setMotherBrandEdit(true);
  };

  const handleSaveMotherBrand = async () => {
    if (justView || !onSaveMotherBrand) return;
    const next = motherBrandDraft.trim().toUpperCase();
    const prev = salesOrderData?.motherBrand
      ? String(salesOrderData.motherBrand).trim().toUpperCase()
      : "";
    if (next === prev) {
      setMotherBrandEdit(false);
      return;
    }
    setSavingMotherBrand(true);
    try {
      const ok = await onSaveMotherBrand(next);
      if (ok) setMotherBrandEdit(false);
    } finally {
      setSavingMotherBrand(false);
    }
  };

  // console.log("salesOrderData details: ", salesOrderData);
  // console.log("log is: ", log);

  return (
    <div className="sales-order-form">
      <div className="sales-order-field">
        <div className="sales-order-field-name">Party Name</div>
        <div className="sales-order-input-parent">
          <Input
            className="custom-input-bdf"
            value={salesOrderData?.parentCompanyName?.toUpperCase()}
            onChange={(e) =>
              handleFormChange("parentCompanyName", e.target.value)
            }
            readOnly={justView}
            style={{
              backgroundColor:
                log &&
                  salesOrderData?.parentCompanyName !== log?.parentCompanyName
                  ? "#fff0f0"
                  : "transparent",
            }}
          />
        </div>
      </div>

      <div className="sales-order-field">
        <div className="sales-order-field-name">Brand Name</div>
        <div
          className="sales-order-input-parent"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            flexWrap: "wrap",
          }}
        >
          <Input
            className="custom-input-bdf"
            value={
              brandEdit
                ? brandDraft
                : salesOrderData?.brandName
                  ? String(salesOrderData.brandName).toUpperCase()
                  : ""
            }
            onChange={(e) => {
              if (brandEdit) setBrandDraft(e.target.value.toUpperCase());
            }}
            readOnly={!brandEdit || justView}
            placeholder="Brand name"
            onPressEnter={() => {
              if (brandEdit && !justView) handleSaveBrand();
            }}
            style={{
              flex: 1,
              minWidth: 160,
              backgroundColor:
                !brandEdit &&
                log &&
                salesOrderData?.brandName !== log?.brandName
                  ? "#fff0f0"
                  : "transparent",
            }}
          />
          {!justView && onSaveBrandName && !brandEdit && (
            <Button
              type="text"
              icon={<EditOutlined />}
              aria-label="Edit brand name"
              onClick={startBrandEdit}
            />
          )}
          {!justView && brandEdit && (
            <>
              <Button
                type="primary"
                size="small"
                loading={savingBrand}
                onClick={handleSaveBrand}
              >
                Save
              </Button>
              <Button
                size="small"
                disabled={savingBrand}
                onClick={() => setBrandEdit(false)}
              >
                Cancel
              </Button>
            </>
          )}
        </div>
      </div>

      <div className="sales-order-field">
        <div className="sales-order-field-name">GST No.</div>
        <div className="sales-order-input-parent">
          <Input
            className="custom-input-bdf"
            value={salesOrderData?.gstNumber}
            onChange={(e) => handleFormChange("gstNumber", e.target.value)}
            readOnly={justView}
            style={{
              backgroundColor:
                log && salesOrderData?.gstNumber !== log?.gstNumber
                  ? "#fff0f0"
                  : "transparent",
            }}
          />
        </div>
      </div>

      <div className="sales-order-field">
        <div className="sales-order-field-name">Mother Brand</div>
        <div
          className="sales-order-input-parent"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            flexWrap: "wrap",
          }}
        >
          <Input
            className="custom-input-bdf"
            value={
              motherBrandEdit
                ? motherBrandDraft
                : salesOrderData?.motherBrand
                  ? String(salesOrderData.motherBrand).toUpperCase()
                  : ""
            }
            onChange={(e) => {
              if (motherBrandEdit) setMotherBrandDraft(e.target.value.toUpperCase());
            }}
            readOnly={!motherBrandEdit || justView}
            placeholder="Enter Mother Brand name"
            onPressEnter={() => {
              if (motherBrandEdit && !justView) handleSaveMotherBrand();
            }}
            style={{
              flex: 1,
              minWidth: 160,
              backgroundColor:
                !motherBrandEdit &&
                log &&
                salesOrderData?.motherBrand !== log?.motherBrand
                  ? "#fff0f0"
                  : "transparent",
            }}
          />
          {!justView && onSaveMotherBrand && !motherBrandEdit && (
            <Button
              type="text"
              icon={<EditOutlined />}
              aria-label="Edit mother brand"
              onClick={startMotherBrandEdit}
            />
          )}
          {!justView && motherBrandEdit && (
            <>
              <Button
                type="primary"
                size="small"
                loading={savingMotherBrand}
                onClick={handleSaveMotherBrand}
              >
                Save
              </Button>
              <Button
                size="small"
                disabled={savingMotherBrand}
                onClick={() => setMotherBrandEdit(false)}
              >
                Cancel
              </Button>
            </>
          )}
        </div>
      </div>

      <div className="sales-order-field">
        <div className="sales-order-field-name">BDF Remark</div>
        <div className="sales-order-input-parent">
          <Input
            className="custom-input-bdf"
            value={salesOrderData?.remark}
            onChange={(e) => handleFormChange("remark", e.target.value)}
            readOnly={justView}
            style={{
              backgroundColor:
                log && salesOrderData?.remark !== log?.remark
                  ? "#fff0f0"
                  : "transparent",
            }}
          />
        </div>
      </div>

      <div className="sales-order-field">
        <div className="sales-order-field-name">Brand Segment</div>
        <div className="sales-order-input-parent">
          <Input
            className="custom-input-bdf"
            value={salesOrderData?.brandSegment?.toUpperCase()}
            onChange={(e) => handleFormChange("brandSegment", e.target.value)}
            readOnly={justView}
            style={{
              backgroundColor:
                log && salesOrderData?.brandSegment !== log?.brandSegment
                  ? "#fff0f0"
                  : "transparent",
            }}
          />
        </div>
      </div>

      <div className="sales-order-field">
        <div className="sales-order-field-name">Campaign Name</div>
        <div className="sales-order-input-parent">
          <Input
            className="custom-input-bdf"
            value={salesOrderData?.campaignName?.toUpperCase()}
            readOnly={true}
            style={{
              backgroundColor:
                log && salesOrderData?.campaignName !== log?.campaignName
                  ? "#fff0f0"
                  : "transparent",
            }}
          />
        </div>
      </div>

      <div className="sales-order-field">
        <div className="sales-order-field-name">Campaign Duration (Days)</div>
        <div className="sales-order-input-parent">
          <Input
            className="custom-input-bdf"
            value={salesOrderData?.campaignDuration}
            onChange={(e) =>
              handleFormChange("campaignDuration", e.target.value)
            }
            readOnly={justView}
            style={{
              backgroundColor:
                log &&
                  salesOrderData?.campaignDuration !== log?.campaignDuration
                  ? "#fff0f0"
                  : "transparent",
            }}
          />
        </div>
      </div>

      <div className="sales-order-field">
        <div className="sales-order-field-name">Sales Person Name</div>
        <div className="sales-order-input-parent">
          <Input
            className="custom-input-bdf"
            value={salesOrderData?.salesPerson}
            readOnly
          />
        </div>
      </div>
      <div className="sales-order-field">
        <div className="sales-order-field-name">BDF Serial No.</div>
        <div className="sales-order-input-parent">
          <Input
            className="custom-input-bdf"
            value={salesOrderData?.bdfStamp}
            readOnly
          />
        </div>

      </div>


      <div className="sales-order-field">
        <div className="sales-order-field-name">SO Remark</div>
        <div className="sales-order-input-parent">
          <Input
            className="custom-input-bdf"
            value={salesOrderData?.soRemark}
            onChange={(e) => handleFormChange("soRemark", e.target.value)}
          />
        </div>
      </div>

      <div className="sales-order-field">
        <div className="sales-order-field-name">BDF Created By</div>
        <div className="sales-order-input-parent">
          <Input className="custom-input-bdf" value={salesOrderData?.createdByName || "N/A"} />
        </div>
      </div>

      {salesOrderData?.stamp && (
        <div className="sales-order-field">
          <div className="sales-order-field-name">Sales Order ID</div>
          <div className="sales-order-input-parent">
            <Input
              className="custom-input-bdf"
              value={salesOrderData?.stamp}
              // onChange={(e) => handleFormChange("stamp", e.target.value)}
              readOnly={justView}
            />
          </div>
        </div>
      )}

      {salesOrderData?.soCreatedByName && (
        <div className="sales-order-field">
          <div className="sales-order-field-name">SO Created By</div>
          <div className="sales-order-input-parent">
            <Input
              className="custom-input-bdf"
              value={salesOrderData?.soCreatedByName}
              readOnly
            />
          </div>
        </div>
      )}

      {salesOrderData?.soUpdatedByName && (
        <div className="sales-order-field">
          <div className="sales-order-field-name">SO Updated By</div>
          <div className="sales-order-input-parent">
            <Input
              className="custom-input-bdf"
              value={salesOrderData?.soUpdatedByName}
              readOnly
            />
          </div>
        </div>
      )}

    </div>
  );
};

export default SalesOrderForm;
